<template>
  <div class="login-head">
    <div><img @click="()=>{this.$router.push('/')}" class="img" src="../../../images/logo.png" alt="" /></div>
    <div class="title">欢迎来到百生跃！</div>
    <div v-if="this.$route.query.type == 'register' || this.$route.query.type == 'forget'" class='back'><div>已激活 <span @click="()=>{this.$router.push('/')}" style="color:#e6a23c;text-decoration-line: underline;cursor:pointer;">回首页</span></div></div>
  </div>
</template>

<script>
export default {
  methods: {
    register(){
      this.$router.push('./register')
    }
  },
}
</script>

<style lang="less" scoped>
.login-head{
    width: 1200px;
    height: 117px;
    background: #003871;
    border-radius: 9px 9px 0px 0px;
    display: flex;
    .img{
      width: 157px;
      height: 50px;
      margin-left: 107px;
      margin-top: 37px;
    }
    .title{
        width: 480px;
        height: 52px;
        font-size: 40px;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        letter-spacing: 20px;
        margin-left: 105px;
        margin-top: 33px;
    }
    .back{
      color:#fff;
      font-size:14px;
      display: flex;
      flex:1;
      padding-right:20px;
      align-items: center;
      justify-content: flex-end;
    }
}
</style>